import { getAssistantConfig } from './config';

export default getAssistantConfig;
